





































import Vue from "vue";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";

import AudioElement from "@tt-app/components/exercise/common/AudioElement.vue";
import ExerciseHtmlText from "@tt-app/components/exercise/consolidated/exercise/body/ExerciseHtmlText.vue";
import Separator from "@tt-app/components/ui/Separator.vue";
import { concatenatedStringArray } from "@tt-app/utils";

import IconMuscular from "@joyz/app-core/assets/icons/white/Muscular.svg";

interface Methods {
  concatenatedBody: (body: string | string[]) => string;
  onEnded: () => void;
}

interface Computed {
  audioUrlInFooter: string;
  questionNumber: string;
}

interface Props {
  audioDecoderPlayer: AudioDecoderPlayer;
  currentQuestionIndex: number;
  header: any;
  body: any;
  footer: any;
  practiceMode: boolean;
  totalQuestions: number;
}

export default Vue.extend<{}, Methods, Computed, Props>({
  name: "TypingQuestion",
  components: {
    AudioElement,
    ExerciseHtmlText,
    Separator
  },
  props: {
    audioDecoderPlayer: {
      type: AudioDecoderPlayer,
      required: true
    },
    currentQuestionIndex: {
      type: Number,
      required: true
    },
    header: {
      type: Array,
      required: true
    },
    body: {
      type: Array,
      required: true
    },
    footer: {
      type: Array,
      required: true
    },
    practiceMode: {
      type: Boolean,
      default: false
    },
    totalQuestions: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      icons: {
        muscular: IconMuscular
      }
    };
  },
  computed: {
    audioUrlInFooter() {
      return this.footer?.[0]?.url || "";
    },
    questionNumber() {
      if (this.currentQuestionIndex !== undefined) {
        return `Q${this.currentQuestionIndex}`;
      } else {
        return this.header[0];
      }
    }
  },
  methods: {
    concatenatedBody(elementBody) {
      return concatenatedStringArray(elementBody);
    },

    onEnded() {
      this.$emit("ended");
    }
  }
});
